var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAdvertisement = function SvgIconAdvertisement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.525 70A46.135 46.135 0 0 0 93 52.377C93 26.764 72.181 6 46.5 6S0 26.764 0 52.377C0 58.616 1.235 64.567 3.475 70h86.05Z",
    fill: "#E1F7F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.01 18.129H17.14v35.46h57.87v-35.46Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.79 53.67H17.21c-.55 0-.99-.44-.99-.99V18.13c0-.55.44-.99.99-.99h57.58c.55 0 .99.44.99.99v34.55c0 .55-.44.99-.99.99Zm-56.6-1.98h55.62V19.11H18.19v32.58Z",
    fill: "#45BEAB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 51.23h70c0 2.94-2.39 5.33-5.33 5.33H16.33c-2.94.01-5.33-2.38-5.33-5.33Z",
    fill: "#45BEAB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.73 50.86h10.54c0 1.09-.89 1.98-1.98 1.98H42.7c-1.09 0-1.98-.89-1.98-1.98h.01Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M64.98 2.69h-35.1c-.44 0-.8.36-.8.8v42.72c0 .36.29.66.66.66h35.24c.36 0 .66-.29.66-.66V3.35a.66.66 0 0 0-.66-.66Z",
    fill: "#DBE0E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.36 5.38h36.55v37.79c0 .55-.45 1-1 1H27.36c-.55 0-1-.45-1-1V5.38Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.36 0h34.55c.55 0 1 .534 1 1.186V6.38H26.36V1.186c0-.652.45-1.186 1-1.186Z",
    fill: "#07917B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.77 4.77a1.49 1.49 0 1 0 0-2.98 1.49 1.49 0 0 0 0 2.98Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.53 4.77a1.49 1.49 0 1 0 0-2.98 1.49 1.49 0 0 0 0 2.98Z",
    fill: "#A9E4DC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.289 4.77a1.49 1.49 0 1 0 0-2.98 1.49 1.49 0 0 0 0 2.98Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.17 30.88H31.66a.66.66 0 0 1-.66-.66c0-.37.29-.66.66-.66h20.51c.36 0 .66.29.66.66 0 .37-.29.66-.66.66ZM39.47 34.449h-7.82a.66.66 0 0 1-.66-.66c0-.37.29-.66.66-.66h7.82c.36 0 .66.29.66.66 0 .37-.29.66-.66.66ZM37.96 38.02h-6.3a.66.66 0 0 1-.66-.66c0-.37.29-.66.66-.66h6.3c.36 0 .66.29.66.66 0 .37-.29.66-.66.66Z",
    fill: "#A9E4DC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.35 9.05H41.91v15.72h27.44V9.05Z",
    fill: "#45BEAB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.77 16.412a2.57 2.57 0 1 0 0-5.14 2.57 2.57 0 0 0 0 5.14ZM52.22 22.9l7.76-9.4 7.76 9.4H52.21h.01Z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m46.7 22.9 4.8-5.81 4.8 5.81h-9.6Z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m59 34 3.773 10.766.957-5.36 4.69-1.094L59 34Z",
    fill: "#07917B"
  })));
};
export default SvgIconAdvertisement;